import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DurchfuehrungsTag, Product } from './Product.js';

/**
 * @entity ProductSCH
 */
@Entity()
export class ProductSCH extends Product {
  public static override _class = 'ProductSCH';

  @Field(() => String)
  public location: Maybe<string>;

  @Field(() => [DurchfuehrungsTag], { default: v => v ?? [] })
  public durchfuehrungsTage!: DurchfuehrungsTag[];
}
